export const cn = {
    overview: {
        intro: '1.9亿专利、1.92亿期刊文献，2.6亿物质数据 <br/>自研AI模型提取专业数据',
        upgrade: '立即体验',
        property: '材料性能探索',
        structure: '化学结构检索',
        composition: '元素组成检索',
        formula: '材料配方检索',
        monitor: {
            title: '监控洞察',
            content: '快速了解关键技术<br/>实时关注行业动向',
        },
        project: {
            title: '技术预研报告',
            content: '一键生成技术趋势发展报告<br/>快速梳理相关技术方案',
        },
        novelty: {
            title: '技术查新',
            content: '及时验证新想法<br/>规避潜在风险',
        },
        disclosure: {
            title: '交底书助手',
            content: '辅助撰写专利技术交底书<br/>提高工作效率',
        },
        eurekaBasic: 'Eureka基础版',
        eurekaTrial: 'Eureka企业版试用',
        current: '（当前）',
        basicFunction: {
            title: '基础功能',
            content: '1.9亿专利文献，智能检索等',
        },
        searchResult: {
            title: '检索结果',
            content: '限制40条',
        },
        download: {
            title: 'PDF下载',
            content: '不支持',
        },
        advancedFunction: {
            title: '高级功能<br/>（交底书等）',
            content: '限制次数',
        },
        materialPackage: '材料专业版',
        materialPackage1: '包含所有基础功能',
        materialPackage2: '所有搜索结果可见',
        materialPackage3: '支持下载',
        materialPackage4: '无次数限制',
        materialOnly: '材料专属',
        materialPackageOnly1: '特征属性检索',
        materialPackageOnly2: '结构式检索',
        materialPackageOnly3: '化合物/合金检索',
        freeInfo: '7天免费体验，感受Materials带来的变化',
        freeTip1: '·自动继承当前版本所有功能和使用记录',
        freeTip2: '·7天试用结束后，自动回到当前版本',
        success: '成功升级到 Eureka材料版',
        successBtn: '立即进入',
    },
};
export const en = {
    overview: {
        intro: 'Based on <span class=\'font-semibold\'>190+ million</span> patents and <span class=\'font-semibold\'>190+ million</span> literature articles, our<br/><span class=\'font-semibold\'>self-developed AI model</span> extracts data specific to material science',
        upgrade: 'Get Started Now',
        property: 'Explore Properties',
        structure: 'Explore Structure',
        composition: 'Element Composition',
        formula: 'Formula Search',
        monitor: {
            title: 'Monitoring insights',
            content: 'Quickly understand key technologies and stay up-to-date with industry trends in real-time',
        },
        project: {
            title: 'Technical Research Report',
            content: 'One click generation of technology trend development reports, quick sorting of relevant technical solutions',
        },
        novelty: {
            title: 'Novelty check',
            content: 'Instant validation of new ideas and avoidance of potential risks',
        },
        disclosure: {
            title: 'Invention Disclosure Assistant',
            content: 'Write invention disclosure documents in one click',
        },
        eurekaBasic: 'Eureka Basic',
        eurekaTrial: 'Eureka Enterprise Trial',
        current: '（Current）',
        basicFunction: {
            title: 'Basic Function',
            content: '190M patent & literature, technical searches, etc',
        },
        searchResult: {
            title: 'Search Result',
            content: '40 results per patent',
        },
        download: {
            title: 'PDF Download',
            content: 'Not supported',
        },
        advancedFunction: {
            title: 'Advance Function<br/>(AI Disclosure, etc)',
            content: 'Limited',
        },
        materialPackage: 'Eureka Materials',
        materialPackage1: 'Include all basic functions',
        materialPackage2: 'Display all results',
        materialPackage3: 'Download supported',
        materialPackage4: 'Unlimited',
        materialOnly: 'Material Only',
        materialPackageOnly1: 'Property Search',
        materialPackageOnly2: 'Formula Search',
        materialPackageOnly3: 'Compounds/Alloy Search',
        freeInfo: '7 days free trial to experience everything Eureka Materials has to offer',
        freeTip1: '·Automatically inherit all features and usage records of the current version',
        freeTip2: '·After the 7 day trial ends, it will automatically revert to the current version',
        success: 'Successfully upgraded to Eureka Materials',
        successBtn: 'Enter Now',
    },
};
